@let apiResponse = data();
@if (apiResponse) {
  <p-table
    [value]="apiResponse.data"
    [loading]="raadgiverService.datasource.isLoading()"
    [showGridlines]="true"
    [scrollable]="true"
    scrollHeight="flex"
    stripedRows
    class="p-datatable-sm lp-table"
    selectionMode="single"
    [metaKeySelection]="true"
    (onRowSelect)="onRowSelect($event)"
    dataKey="id"
    [lazy]="true"
    [lazyLoadOnInit]="false"
    (onLazyLoad)="onLazyLoad($event)"
    sortField="raadgiver.fornavn"
    [sortOrder]="1"
    [paginator]="true"
    [rows]="100"
    [totalRecords]="apiResponse.totalRowCount"
    [showJumpToPageDropdown]="true"
    letKeepScrollPosition>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="raadgiver.fornavn">
          Navn
          <p-sortIcon field="raadgiver.fornavn" />
        </th>
        <th pSortableColumn="raadgiver.brugerId" style="width: 160px">
          Bruger id
          <p-sortIcon field="raadgiver.brugerId" />
        </th>
        <th pSortableColumn="pengeinstitut.navn">
          Pengeinstitut
          <p-sortIcon field="pengeinstitut.navn" />
        </th>
        <th pSortableColumn="pengeinstitut.hovedRegNr">
          Regnr
          <p-sortIcon field="pengeinstitut.hovedRegNr" />
        </th>
        <th pSortableColumn="raadgiver.inaktivering" style="width: 140px">
          Deaktiveret
          <p-sortIcon field="raadgiver.inaktivering" />
        </th>
        <th pSortableColumn="raadgiver.email" style="width: 200px">
          Email
          <p-sortIcon field="raadgiver.email" />
        </th>
      </tr>
    </ng-template>
    <ng-template [appTableRow]="apiResponse.data" pTemplate="body" let-item>
      <tr [pSelectableRow]="item" class="cursor-pointer">
        <td>{{ item.navn }}</td>
        <td>{{ item.brugerId }}</td>
        <td>{{ item.pengeinstitut?.navn }}</td>
        <td>{{ item.pengeinstitut?.regnr }}</td>
        <td>{{ item.inaktivering | date: 'dd-MM-yyyy' }}</td>
        <td>{{ item.email }}</td>
      </tr>
    </ng-template>
  </p-table>
}
